module.exports = __webpack_public_path__ + "img/SER-B-2-III.3c0919c5.png";